import axios from "axios";

const api = axios.create({
  baseURL: "https://apiphpcl.condutorlegal.com.br/ecommerce-app-api/apicdl/"
  //url : 'https://apicdlrelease.azurewebsites.net/apicdl/'
});

export default api;